<div *ngIf="processing" class="disclaimer">{{ 'exportando' | translate}}</div>
<div *ngIf="waiting" class="disclaimer">{{ 'iniciar_exportar_analisis' | translate}}</div>
<div *ngIf="waiting || processing" class="waiting">{{ 'esta_operacion_minutos' | translate}}</div>

<div *ngIf="error" class="disclaimer">{{ 'error_exportar_analisis' | translate}}</div>
<div *ngIf="exported" class="disclaimer">{{ 'finalizado_exportar_analisis' | translate}}</div>

<div class="buttons">
  <button *ngIf="waiting" class="cancel" (click)="close()">{{ 'cancelar' | translate}}</button>
  <button *ngIf="waiting" class="submit" (click)="export()">{{ 'exportar' | translate}}</button>
  <button *ngIf="exported || error" class="submit" (click)="close()">{{ 'cerrar' | translate}}</button>
</div>
